import React, { useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';
import Notiflix from 'notiflix';
import emailjs from 'emailjs-com';

const DemoProduct = () => {
  useDocTitle('JSS The Print Zone');

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [demoProducts, setDemoProducts] = useState([]);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;
    setErrors({ ...errors, products: '' });
    if (checked) {
      setDemoProducts([...demoProducts, value]);
    } else {
      setDemoProducts(demoProducts.filter((e) => e !== value));
    }
  };

  const clearErrors = () => setErrors({});

  const clearInput = () => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setPhone('');
    setMessage('');
    setDemoProducts([]);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!firstName.trim()) newErrors.first_name = 'First name is required';
    if (!lastName.trim()) newErrors.last_name = 'Last name is required';
    if (!email.trim()) newErrors.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) newErrors.email = 'Invalid email format';
    if (!phone.trim()) newErrors.phone_number = 'Phone number is required';
    else if (!/^\d{10}$/.test(phone)) newErrors.phone_number = 'Enter a valid 10-digit phone number';
    if (!message.trim()) newErrors.message = 'Message is required';
    if (demoProducts.length === 0) newErrors.products = 'Please select at least one product';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  function sendEmail(e) {
    e.preventDefault();
    if (!validateForm()) return;

    document.getElementById('submitBtn').disabled = true;
    document.getElementById('submitBtn').innerHTML = 'Loading...';

    const templateParams = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone_number: phone,
      message: message,
      products: demoProducts.join(', '),
      time: new Date().toLocaleString(),
    };

    emailjs.send('service_g19xoio', 'template_m23s97i', templateParams, 'qaQ-OIfHbUs0zHYG8')
      .then(() => {
        document.getElementById('submitBtn').disabled = false;
        document.getElementById('submitBtn').innerHTML = 'Send Message';
        clearInput();
        Notiflix.Report.success('Success', 'Message sent successfully!', 'Okay');
      })
      .catch(() => {
        document.getElementById('submitBtn').disabled = false;
        document.getElementById('submitBtn').innerHTML = 'Send Message';
        Notiflix.Report.failure('An error occurred', 'Please try again.', 'Okay');
      });
  }

  return (
    <>
      <NavBar />
      <div id='demo' className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24">
        <div className="container mx-auto my-8 px-4 lg:px-20" data-aos="zoom-in">
          <form onSubmit={sendEmail} id="demoProductForm">
            <div className="w-full bg-white p-8 my-4 md:px-12 lg:w-9/12 lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl">
              <h1 className="font-bold text-center lg:text-left text-blue-900 uppercase text-4xl">
                Demo Our Packaging Products
              </h1>
              <p className="mt-4 text-gray-600 font-medium">
                Select the type of packaging you're interested in. We'll reach out with samples and tailored solutions.
              </p>

              {["Mono Cartons (Cosmetic Boxes)", "Rigid Boxes (Luxury Packaging)", "Printed Labels (Roll Form/Die-cut)", "Window Patch Boxes & Inserts"].map((label, idx) => (
                <div key={idx} className="flex items-center my-4">
                  <input
                    id={`checkbox-${idx}`}
                    type="checkbox"
                    className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded"
                    value={label}
                    onChange={handleChange}
                  />
                  <label htmlFor={`checkbox-${idx}`} className="ml-3 text-lg font-medium text-gray-900">
                    {label}
                  </label>
                </div>
              ))}
              {errors.products && <p className="text-red-500 text-sm">{errors.products}</p>}

              <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
                {[{ name: 'first_name', value: firstName, setValue: setFirstName, placeholder: 'First Name*' },
                  { name: 'last_name', value: lastName, setValue: setLastName, placeholder: 'Last Name*' },
                  { name: 'email', value: email, setValue: setEmail, placeholder: 'Email*', type: 'email' },
                  { name: 'phone_number', value: phone, setValue: setPhone, placeholder: 'Phone*', type: 'number' }].map((field, idx) => (
                    <div key={idx}>
                      <input
                        name={field.name}
                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                        type={field.type || 'text'}
                        placeholder={field.placeholder}
                        value={field.value}
                        onChange={(e) => field.setValue(e.target.value)}
                        onKeyUp={clearErrors}
                      />
                      {errors[field.name] && <p className="text-red-500 text-sm">{errors[field.name]}</p>}
                    </div>
                  ))}
              </div>

              <div className="my-4">
                <textarea
                  name="message"
                  placeholder="Message*"
                  className="w-full h-32 bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  onKeyUp={clearErrors}
                ></textarea>
                {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
              </div>

              <div className="my-2 w-1/2 lg:w-2/4">
                <button
                  type="submit"
                  id="submitBtn"
                  className="uppercase text-sm font-bold tracking-wide bg-gray-500 hover:bg-blue-900 text-gray-100 p-3 rounded-lg w-full focus:outline-none focus:shadow-outline"
                >
                  Send Message
                </button>
              </div>
            </div>
          </form>

          <div className="w-full lg:-mt-96 lg:w-2/6 px-8 py-6 ml-auto bg-blue-900 rounded-2xl text-white">
            <div className="mb-4">
              <h2 className="text-2xl font-bold">Office Address</h2>
              <p className="text-gray-300">JSS The Print Zone, 39, DSIDC Sheds, Okhla Phase-II, New Delhi-110020</p>
            </div>
            <div className="mb-4">
              <h2 className="text-2xl font-bold">Call Us</h2>
              <p className="text-gray-300">+91 98912 58552</p>
            </div>
            <div className="mb-4">
              <h2 className="text-2xl font-bold">Send an E-mail</h2>
              <p className="text-gray-300">jssgraphics@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DemoProduct;